import React from 'react';
import Link from 'components/Link';
import PropTypes from 'prop-types';
import ImageV2 from 'components_v2/common/ImageV2';
import { dateToStringWithFormat } from 'utils/dateUtils';
import s from './VocCard.scss';
import { TOI_IMAGE_DOMAIN, TOI_LIVE_DOMAIN } from '../../../constants/index';

function VocCard({
  title,
  msid,
  imageid,
  seopath,
  //isWapView,
  width,
  wu,
  lazyloadImg,
  metainfo,
  syn,
  dl,
  author,
  overridelink,
  otherPageWidget,
  noLinkMobile,
}) {
  const ImageElement = ImageV2;
  const path = `${TOI_LIVE_DOMAIN}/${seopath}/articleshow/${msid}.cms`;

  return (
    <div className={`${s.vocCard} ${otherPageWidget ? s.otherPageView : ''}`}>
      <div className={s.firstSection}>
        {overridelink && !noLinkMobile ? (
          <Link to={wu || path}>
            <figure className={s.vocImageWrap}>
              <div className={s.content}>
                <ImageElement
                  width={width || '600'}
                  msid={imageid}
                  placeHolderSrc={`${TOI_IMAGE_DOMAIN}/photo/87458172.cms`}
                  alt={title}
                  lazyload={lazyloadImg}
                  offsetVertical={300}
                />
              </div>
            </figure>
          </Link>
        ) : (
          <figure className={s.vocImageWrap}>
            <div className={s.content}>
              <ImageElement
                width={width || '600'}
                msid={imageid}
                placeHolderSrc={`${TOI_IMAGE_DOMAIN}/photo/87458172.cms`}
                alt={title}
                lazyload={lazyloadImg}
                offsetVertical={300}
              />
            </div>
          </figure>
        )}
        <div className={`${s.photoTitleWrap}`}>
          <div className={s.flex}>
            <div className={s.mainText}>
              {overridelink && !noLinkMobile ? (
                <Link to={wu || path}>{title}</Link>
              ) : (
                title
              )}
            </div>
            <div className={s.subText}>
              {metainfo?.BirthDateText?.value || ''}
            </div>
          </div>
          {author && (
            <div className={`${s.authorDetails} ${s.flex}`}>
              <div className={s.adText}>{author}</div>
              <div className={s.adSubText}>(Photographer)</div>
            </div>
          )}
        </div>
      </div>
      <div className={s.secondSection}>
        <div className={`${s.toiTake} ${s.flex}`}>
          <div className={s.ttText}>TOI take:</div>
          {dl && (
            <div className={s.ttSubText}>
              Published on: {dateToStringWithFormat(dl, ' MMM DD, YYYY')}
            </div>
          )}
        </div>
        {syn && <div className={s.vocContent}>{syn}</div>}
      </div>
    </div>
  );
}

VocCard.propTypes = {
  seopath: PropTypes.string,
  msid: PropTypes.string,
  title: PropTypes.string,
  //isWapView: PropTypes.bool,
  lazyloadImg: PropTypes.bool,
  width: PropTypes.string,
  wu: PropTypes.string,
  syn: PropTypes.string,
  author: PropTypes.string,
  imageid: PropTypes.string,
  overridelink: PropTypes.string,
  otherPageWidget: PropTypes.bool,
  noLinkMobile: PropTypes.string,
};
VocCard.defaultProps = {
  seopath: '',
  title: '',
  msid: '',
  //isWapView: false,
  lazyloadImg: true,
  width: '',
  wu: '',
  syn: '',
  author: '',
  imageid: '',
  overridelink: false,
  otherPageWidget: false,
  noLinkMobile: false,
};

export default VocCard;
